export default "__VITE_ASSET__gk5Xr0aE__"